// src/pages/Inicial.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card/Card";
import SecaoAutomatica from "../components/Secoes/SecaoAutomatica";
import SecaoManual from "../components/Secoes/SecaoManual";
import projetosData from "../data/projetosGerais.json";
import secoesManuais from "../data/secoesManuais.json";

function Inicial({ filtro, pesquisa }) {

    const navigate = useNavigate();

    const handleCardClick = (id) => {
        navigate(`/projeto/${id}`);
    };

    // Função de filtragem global
    function filtrarProjetos() {
        let projetos = [...projetosData];

        // Se houver pesquisa, prioriza ela
        if (pesquisa && pesquisa.trim() !== "") {
            return projetos.filter(
                (proj) =>
                    proj.titulo.toLowerCase().includes(pesquisa.toLowerCase()) ||
                    proj.descricao.toLowerCase().includes(pesquisa.toLowerCase())
            );
        }

        // Se houver filtro ativo
        if (filtro && filtro !== "todos") {
            return projetos.filter((proj) => proj.tags.includes(filtro));
        }

        // Caso contrário → sem filtros/pesquisa
        return null;
    }

    const projetosFiltrados = filtrarProjetos();

    return (
        <div>
            <h1>Portfólio de Tecnologias Educacionais</h1>

            {projetosFiltrados ? (
                // 🔹 Lista filtrada simples
                <div className="cards-container">
                    {projetosFiltrados.map((projeto) => (
                        <Card key={projeto.id} projeto={projeto} onClick={handleCardClick} />
                    ))}
                </div>
            ) : (
                // 🔹 Estado inicial (sem filtros/pesquisa) → renderiza seções
                <>
                    {/* Seções manuais (ex: Destaques, Novidades) */}
                    {Object.entries(secoesManuais).map(([titulo, ids]) => (
                        <SecaoManual
                            key={titulo}
                            titulo={titulo}
                            ids={ids}
                            projetos={projetosData}
                        />
                    ))}

                    {/* Seções automáticas (tags principais) */}
                    <SecaoAutomatica
                        titulo="Realidade Virtual"
                        tag="RV"
                        id="secao-rv"
                        projetos={projetosData}
                    />
                    <SecaoAutomatica
                        titulo="Realidade Aumentada"
                        tag="RA"
                        id="secao-ra"
                        projetos={projetosData}
                    />
                    <SecaoAutomatica
                        titulo="Vídeo 360"
                        tag="Vídeo 360"
                        id="secao-video360"
                        projetos={projetosData}
                    />
                    <SecaoAutomatica
                        titulo="Vídeo 360i"
                        tag="Vídeo 360i"
                        id="secao-video360i"
                        projetos={projetosData}
                    />
                </>
            )}
        </div>
    );
}

export default Inicial;
